const ADULT_PRODUCT_IMAGE_PLACEHOLDER_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

const ADULT_PRODUCT_IMAGE_PLACEHOLDER_VIEW_TYPES = {
  DEFAULT: 'default',
  COLORED: 'colored',
}

export {
  ADULT_PRODUCT_IMAGE_PLACEHOLDER_SIZES,
  ADULT_PRODUCT_IMAGE_PLACEHOLDER_VIEW_TYPES,
}
